// src/components/ScrollToHash.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      let elem = document.getElementById(location.hash.slice(1));
      if (elem) {
        // Use setTimeout to ensure the element is rendered and the page is stable
        setTimeout(() => {
          elem.scrollIntoView({ behavior: 'smooth' });
        }, 100); // A small delay can help if components are still mounting
      }
    } else {
      // If no hash, scroll to top when route changes (optional, but good for general navigation)
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]); // Re-run effect when location changes (route or hash)

  return null; // This component doesn't render anything itself
}

export default ScrollToHash;